import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { useState } from "react";

import { Button } from "@/components/ui/button/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { RepaymentRequest } from "./schema";
import { useTakeActionModal } from "../take-action-on-repayment-request/use-action-modal";
import { useViewModal } from "../view-repayment-request-modal/use-view-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as RepaymentRequest;

  const [open, setOpen] = useState(false);

  const { onOpenChange, setRepaymentRequestId } = useTakeActionModal();

  const { setRepaymentRequest, onOpenChange: onOpenViewModal } = useViewModal();

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[220px]">
        <DropdownMenuItem
          onMouseDown={() => {
            setRepaymentRequestId(originData?.id);
            onOpenChange(true);
            setOpen(false);
          }}
        >
          Take Action
        </DropdownMenuItem>
        <DropdownMenuItem
          onMouseDown={() => {
            setRepaymentRequest(originData);
            onOpenViewModal(true);
            setOpen(false);
          }}
        >
          View Repayment Request
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
